import { Field, FieldProps, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import FormikTextbox from "src/components/Common/UI/Formik/FormikTextbox";


const UserInspectorSearchForm = ({ initialValues, onSubmit, onClearForm }: UserInspectorSearchFormProps) => {
  const { t } = useTranslation();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, formikHelpers) => {
        onSubmit(values, formikHelpers);
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <Container fluid className="p-0">
            <Row>
            <label className="form-label">
                {t("Ημερομηνία")}
                </label>
              
              <Col xs={6}>
                <label className="form-label">
                {t("Από")}
                </label>
                <Field 
                  name="datetimeFrom"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="datetimeFrom"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value && field.value.toLocaleDateString('el-GR').split('/').join('-')} 
                      className="form-control"
                      dateFormat={"dd-MM-yyyy"}
                    />
                  )}
                </Field>               
              </Col>

              <Col xs={6}>
                <label className="form-label">
                {t("Έως")}
                </label>
                <Field 
                  name="datetimeTo"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="datetimeTo"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value && field.value.toLocaleDateString('el-GR').split('/').join('-')} 
                      className="form-control"
                      dateFormat={"dd-MM-yyyy"}
                    />
                  )}
                </Field>               
              </Col>

              <Col xs={6}>
                <FormikTextbox
                  label={"Όνομα"}
                  fieldName={"username"}
                />
              </Col>

            </Row>
            <Row className="row justify-content-end">
              <Col xs="2" className="m-2 me-0">
                <Button
                  type="button"
                  size="sm"
                  color="warning"
                  disabled={isSubmitting}
                  onClick={onClearForm}
                >
                  {t("Καθαρισμός")}
                </Button>
              </Col>

              <Col xs="2" className="m-2">
                <Button
                  type="submit"
                  size="sm"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {t("Αναζήτηση")}
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      )}
    </Formik>
  )
}

export default UserInspectorSearchForm;

type UserInspectorSearchFormProps = {
  initialValues: IUserInspectorSearchForm;
  onSubmit: (
    values: IUserInspectorSearchForm,
    formikHelpers: FormikHelpers<IUserInspectorSearchForm>
  ) => void;
  onClearForm: () => void;
}